/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import getUsers from "../../../actions/users";

class UserFilter extends Component {
  componentDidMount() {
    this.props.getUsers();
  }

  handleUserChange = selectedUser => {
    if (selectedUser) {
      this.props.onChange(selectedUser.value);
    } else {
      this.props.onChange("");
    }
  };

  render() {
    const { value } = this.props;
    const userOptions = this.props.users
      .map(user => ({
        value: `${user.id}`,
        label: `${user.firstName} ${user.lastName}`
      }))
      .sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        return 0;
      });

    return (
      <Select
        className="filter-select"
        name="user"
        value={value}
        onChange={this.handleUserChange}
        options={userOptions}
        placeholder="Filter by driver"
        resetValue=""
      />
    );
  }
}
UserFilter.propTypes = {
  value: PropTypes.string,
  users: PropTypes.array,
  getUsers: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
UserFilter.defaultProps = {
  value: "",
  users: []
};

const mapStateToProps = state => ({ users: state.users.container });
const mapDispatchToProps = { getUsers };

export default connect(mapStateToProps, mapDispatchToProps)(UserFilter);



// WEBPACK FOOTER //
// ./src/components/runsheets/list/UserFilter.js